	namespace $ {

	export type $shm_hitalama_transfer_map_dump = $shm_hitalama_transfer_dump
	export type $shm_hitalama_transfer_map_widgets_dump = {
		format: 'hitalama_transfer_map_widgets'
		root_links: string[]
		nodes: $shm_hitalama_transfer_node[]
	}

	export class $shm_hitalama_transfer_map extends $shm_hitalama_transfer {

		map(): $shm_hitalama_map {
			throw new Error('Not implemented')
		}

		entity(): $giper_baza_dict {
			return this.map()
		}

		include_files() {
			return true
		}

		protected should_serialize_field(
			owner: $giper_baza_dict,
			field: string,
			field_pawn: any,
		) {
			if( owner instanceof $shm_hitalama_map_widget && field === 'Inside_widget' ) return false
			if( !this.include_files() ) {
				if( field_pawn instanceof $giper_baza_file ) return false
				if( field_pawn instanceof $giper_baza_atom_link && ( field_pawn as any ).remote?.() instanceof $giper_baza_file ) return false
			}

			if( owner === this.map() ) {
				if( field === 'Widget_by_name' ) return false
				if( field === 'Presences' ) return false
			}

			return super.should_serialize_field( owner, field, field_pawn )
		}

		protected should_serialize_node( context: $shm_hitalama_transfer_node_context ) {
			if( context.node === this.map() && context.owner !== this.map() ) return false
			if( !this.include_files() && context.node instanceof $giper_baza_file ) return false
			return super.should_serialize_node( context )
		}

		protected follow_serialize_node(
			owner: $giper_baza_dict,
			field: string,
			kind: Extract< $shm_hitalama_transfer_field_kind, 'link' | 'links' | 'owned' >,
			target: $giper_baza_dict | null,
			visited: Map< string, $shm_hitalama_transfer_node >,
		) {
			if( owner instanceof $shm_hitalama_map_widget && field === 'Widgets' && target ) {
				target = target.cast( $shm_hitalama_map_widget )
			}

			return super.follow_serialize_node( owner, field, kind, target, visited )
		}

		serialize_map(): $shm_hitalama_transfer_map_dump {
			return super.serialize()
		}

		protected widget_descendants( widget: $shm_hitalama_map_widget ): readonly $shm_hitalama_map_widget[] {
			return widget.widgets().flatMap( child => [ child, ... this.widget_descendants( child ) ] )
		}

		protected widget_descendants_before_parent( widget: $shm_hitalama_map_widget ): readonly $shm_hitalama_map_widget[] {
			return widget.widgets().flatMap( child => [ ... this.widget_descendants_before_parent( child ), child ] )
		}

		protected widget_roots( source: readonly $shm_hitalama_map_widget[] ) {
			const selected = new Set( source.map( widget => widget.link().toString() ) )
			const inner = new Set(
				source.flatMap( widget => this.widget_descendants( widget ).map( child => child.link().toString() ) )
			)

			return source.filter( widget => !inner.has( widget.link().toString() ) || !selected.has( widget.link().toString() ) )
		}

		serialize_widgets( source: readonly $shm_hitalama_map_widget[] ): $shm_hitalama_transfer_map_widgets_dump {
			const visited = new Map< string, $shm_hitalama_transfer_node >()
			const root_links: string[] = []
			const roots = this.widget_roots( source )

			for( const widget of roots ) {
				root_links.push( widget.link().toString() )
				for( const child of [ ... this.widget_descendants_before_parent( widget ), widget ] ) {
					this.serialize_node( child, visited )
				}
			}

			const nodes = [ ...visited.values() ]

			return {
				format: 'hitalama_transfer_map_widgets',
				root_links,
				nodes,
			}
		}

		protected instantiate_collection_node(
			node: $shm_hitalama_transfer_node,
			owner: any,
			field: string,
		) {
			const config = this.child_config( owner ) ?? this.map().land()

			if( owner instanceof $shm_hitalama_map_widget && field === 'Widgets' ) {
				const widget = this.map().Widgets_list(null)?.make( config )?.cast( $shm_hitalama_map_widget )
				widget?.Map(null)?.remote( this.map() )
				return widget
			}

			switch( node.class_name ) {
				case '$shm_hitalama_map_widget': {
					const widget = this.map().Widgets_list(null)?.make( config )?.cast( $shm_hitalama_map_widget )
					widget?.Map(null)?.remote( this.map() )
					return widget
				}
				case '$shm_hitalama_map_widget_entity_table': {
					const table = this.map().Tables(null)?.make( config )
					table?.Map(null)?.remote( this.map() )
					return table
				}
				case '$shm_hitalama_file': {
					if( owner === this.map() && field === 'Files' ) return null
					return this.map().Files(null)?.make( config )
				}
				case '$shm_hitalama_map_widget_entity_custom':
					return this.map().Customs(null)?.make( config )
				case '$shm_hitalama_map_widget_entity_form':
					return this.map().Search_statistics(null)?.make( config )
			}

			return null
		}

		protected instantiate_field_child(
			host: any,
			field: string,
			kind: Extract< $shm_hitalama_transfer_field_kind, 'link' | 'links' | 'owned' >,
			link: string | null,
		) {
			if( !link ) return
			if( this.pawn_by_old_link.has( link ) ) return
			if( !this.should_instantiate_child( host, field, kind, link ) ) return

			const child_dto = this.node_by_old_link.get( link )
			if( !child_dto ) return

			const child = this.instantiate_collection_node( child_dto, host, field )
			if( child ) {
				this.set_mapping( link, child )
				this.instantiate_children( child, child_dto )
				return
			}

			super.instantiate_field_child( host, field, kind, link )
		}

		protected instantiate_entry_child(
			host: any,
			key: string,
			kind: Extract< $shm_hitalama_transfer_field_kind, 'link' | 'links' | 'owned' >,
			link: string | null,
		) {
			if( !link ) return
			if( this.pawn_by_old_link.has( link ) ) return
			if( !this.should_instantiate_child( host, key, kind, link ) ) return

			const child_dto = this.node_by_old_link.get( link )
			if( !child_dto ) return

			const child = this.instantiate_collection_node( child_dto, host, key )
			if( child ) {
				this.set_mapping( link, child )
				this.instantiate_children( child, child_dto )
				return
			}

			super.instantiate_entry_child( host, key, kind, link )
		}

		protected serialize_field(
			field_pawn: any,
		): $shm_hitalama_transfer_field | undefined {
			if( field_pawn instanceof $giper_baza_atom_link ) {
				const remote = ( field_pawn as any ).remote?.()
				if( remote instanceof $giper_baza_dict && !remote.filled() ) return undefined
			}

			return super.serialize_field( field_pawn )
		}

		protected remap_imported_links( value: any ): any {
			if( typeof value === 'string' ) {
				let next = value
				const old_map_link = [ ... this.pawn_by_old_link ].find( ([, pawn]) => pawn === this.map() )?.[0]
				const new_map_link = this.map().link().toString()
				const links = [ ... this.pawn_by_old_link ].sort(
					( [ left ], [ right ] )=> right.length - left.length
				)
				for( const [ old_link, pawn ] of links ) {
					const new_link = pawn?.link?.().toString?.()
					if( !new_link || old_link === new_link ) continue
					next = next.replaceAll( old_link, new_link )
					if( old_map_link && old_link.startsWith( old_map_link + '_' ) ) {
						const old_suffix_on_new_map = new_map_link + old_link.slice( old_map_link.length )
						if( old_suffix_on_new_map !== new_link ) next = next.replaceAll( old_suffix_on_new_map, new_link )
					}
					const old_valid_link = $giper_baza_link.check( old_link )
					if( !old_valid_link ) continue
					const old_head = new $giper_baza_link( old_valid_link ).head().toString()
					if( old_head ) {
						const old_head_on_new_map = new $giper_baza_link( '___' + old_head ).resolve( this.map().link() ).toString()
						if( old_head_on_new_map !== new_link ) next = next.replaceAll( old_head_on_new_map, new_link )
					}
				}
				return next
			}

			if( Array.isArray( value ) ) {
				return value.map( item => this.remap_imported_links( item ) )
			}

			if( value && typeof value === 'object' && Object.getPrototypeOf( value ) === Object.prototype ) {
				return Object.fromEntries(
					Object.entries( value ).map( ([ key, val ]) => [
						key,
						this.remap_imported_links( val ),
					] )
				)
			}

			return value
		}

		protected normalize_field_value( field: string, value: any ) {
			return this.remap_imported_links( super.normalize_field_value( field, value ) )
		}

		protected atom_value( field: $shm_hitalama_transfer_field | undefined ) {
			return field?.kind === 'atom' ? field.value : undefined
		}

		protected text_value( field: $shm_hitalama_transfer_field | undefined ) {
			if( field?.kind === 'atom' || field?.kind === 'text' ) return field.value
			return undefined
		}

		protected normalize_widget_render_data_node( node: $shm_hitalama_transfer_node ) {
			if( node.class_name !== '$shm_hitalama_map_widget' ) return

			const fields = node.fields
			const render = this.atom_value( fields.Render_data )
			const title = render?.title ?? this.atom_value( fields.Title ) ?? node.title ?? node.link
			const type = render?.type ?? this.atom_value( fields.Type ) ?? 'text'
			const text = render?.text ?? this.text_value( fields.Text_atom ) ?? this.text_value( fields.Text ) ?? ''
			const body_x = render?.body_x ?? this.atom_value( fields.Body_x ) ?? 0
			const body_y = render?.body_y ?? this.atom_value( fields.Body_y ) ?? 0
			const right_edge_x = render?.right_edge_x ?? this.atom_value( fields.Right_edge_x ) ?? 0
			const bottom_edge_y = render?.bottom_edge_y ?? this.atom_value( fields.Bottom_edge_y ) ?? 0
			const opacity = render?.opacity ?? this.atom_value( fields.Opacity ) ?? 1

			fields.Render_data = {
				kind: 'atom',
				value: {
					title,
					type,
					text,
					value_refs: render?.value_refs ?? $shm_hitalama_map_widget_value_refs( text ),
					body_x,
					body_y,
					right_edge_x,
					bottom_edge_y,
					opacity,
				},
			}
		}

		protected normalize_render_data( dto: $shm_hitalama_transfer_dump | $shm_hitalama_transfer_map_widgets_dump ) {
			for( const node of dto.nodes ) this.normalize_widget_render_data_node( node )
			return dto
		}

		protected rebuild_widget_index() {
			const dict = this.map().Widget_by_name(null)
			dict?.keys().forEach( key => {
				dict?.key( key )?.remote( null as any )
			} )

			this.map().Widgets_list()?.remote_list().forEach( ( widget: $shm_hitalama_map_widget ) => {
				dict?.key( widget.title(), 'auto' ).remote( widget )
			} )
		}

		protected relink_widget_groups( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			for( const node of dto.nodes ) {
				if( node.class_name !== '$shm_hitalama_map_widget' ) continue

				const group = this.pawn_by_old_link.get( node.link )?.cast?.( $shm_hitalama_map_widget )
				if( group?.type?.() !== 'group' ) continue

				const field = node.fields.Widgets
				if( field?.kind !== 'links' ) continue

				const widgets = field.links.flatMap( link => {
					const widget = this.pawn_by_old_link.get( link )?.cast?.( $shm_hitalama_map_widget )
					if( !widget ) return []
					widget.container_widget( group )
					return [ widget ]
				} )

				group.widgets( widgets )
			}
		}

		deserialize_map( dto: $shm_hitalama_transfer_map_dump ) {
			this.normalize_render_data( dto )

			if( !Array.isArray( dto.nodes ) ) {
				throw new Error( 'Invalid hitalama_transfer dump: nodes should be an array' )
			}

			this.pawn_by_old_link.clear()
			this.node_by_old_link = new Map( dto.nodes.map( node => [ node.link, node ] ) )
			const root = this.node_by_old_link.get( dto.root_link )
			if( !root ) throw new Error( `Transfer root node not found: ${ dto.root_link }` )

			this.set_mapping( dto.root_link, this.entity() )
			this.instantiate_children( this.entity(), root )

			this.deserialize_node_data( this.entity(), root )
			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn || node.link === dto.root_link ) continue
				this.deserialize_node_data( pawn, node )
			}

			this.deserialize_node_links( this.entity(), root )
			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn || node.link === dto.root_link ) continue
				this.deserialize_node_links( pawn, node )
			}

			this.rebuild_widget_index()
		}

		deserialize_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			this.normalize_render_data( dto )
			this.pawn_by_old_link.clear()
			this.node_by_old_link = new Map( dto.nodes.map( node => [ node.link, node ] ) )

			for( const link of dto.root_links ) {
				if( this.pawn_by_old_link.has( link ) ) continue

				const node = this.node_by_old_link.get( link )
				if( !node ) continue

				if( !this.should_deserialize_node({
					owner: this.map(),
					owner_link: this.map().link().toString(),
					field: 'Widgets',
					kind: 'links',
					node,
				}) ) continue

				const widget = this.map().Widgets_list(null)?.make( this.map().land() )?.cast( $shm_hitalama_map_widget )
				if( !widget ) continue

				widget.Map(null)?.remote( this.map() )
				this.set_mapping( link, widget )
				this.instantiate_children( widget, node )
			}

			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn ) continue
				this.deserialize_node_data( pawn, node )
			}

			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn ) continue
				this.deserialize_node_links( pawn, node )
			}

			this.relink_widget_groups( dto )
			this.rebuild_widget_index()
		}

	}

	export class $shm_hitalama_transfer_map_restorer extends $shm_hitalama_transfer_map {
		deserialize_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			this.normalize_render_data( dto )
			this.pawn_by_old_link.clear()
			this.node_by_old_link = new Map( dto.nodes.map( node => [ node.link, node ] ) )

			for( const link of dto.root_links ) {
				if( this.pawn_by_old_link.has( link ) ) continue

				const node = this.node_by_old_link.get( link )
				if( !node ) continue

				if( !this.should_deserialize_node({
					owner: this.map(),
					owner_link: this.map().link().toString(),
					field: 'Widgets',
					kind: 'links',
					node,
				}) ) continue

				const widget = this.map().Widgets_list()?.remote_list().find( ( item: $shm_hitalama_map_widget ) => item.link().toString() === link )
					?? $giper_baza_glob.Pawn( new $giper_baza_link( link ), $shm_hitalama_map_widget )

				if( !widget ) continue

				this.set_mapping( link, widget )
				this.instantiate_children( widget, node )
			}

			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn ) continue
				this.deserialize_node_data( pawn, node )
			}

			for( const node of dto.nodes ) {
				const pawn = this.pawn_by_old_link.get( node.link )
				if( !pawn ) continue
				this.deserialize_node_links( pawn, node )
			}

			this.relink_widget_groups( dto )
			this.rebuild_widget_index()
		}

		protected set_mapping( old_link: string, pawn: any ) {
			this.pawn_by_old_link.set( old_link, pawn )
		}

	}

}
